import { convertDateWithCustomTimezone } from '@/utils/time';

/**
 * Converts a UTC date to a wall clock time in the selected timezone, or vice versa.
 * @param availabilityScheduledAt - The UTC date string or Date object.
 * @param availabilityScheduledAtTimezone - The timezone offset in minutes.
 * @param direction - 'toCustomTimezome' to display in UI, 'fromCustomTimezone' to store in UTC.
 */
export function convertAvailabilityScheduledAtWithTimezone({
  availabilityScheduledAt,
  availabilityScheduledAtTimezone = 0,
  direction,
}: {
  availabilityScheduledAt: string | Date | undefined;
  availabilityScheduledAtTimezone?: number;
  direction: 'toCustomTimezome' | 'fromCustomTimezone';
}): string | undefined {
  if (!availabilityScheduledAt) return undefined;

  return convertDateWithCustomTimezone({
    date: new Date(availabilityScheduledAt),
    customTimezoneOffsetInMinutes: availabilityScheduledAtTimezone,
    convertionDirection: direction,
  }).toISOString();
}
